<template>
    <div v-if="location" class="greeter">{{ location.greeter }}</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'Landing',
    asyncComputed: {
        ...mapState(['location']),
        isHtml(str) {
            return /<\/?[a-z][\s\S]*>/i.test(str)
        },
    },
}
</script>

<style lang="scss">
    .greeter {
        white-space: pre-wrap;
    }
</style>